import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

document.documentElement.setAttribute("lang", "tr");
document.documentElement.setAttribute("translate", "no");
document.documentElement.classList.add("notranslate");
document.body?.setAttribute("translate", "no");
document.body?.classList.add("notranslate");

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <App />
);
